import React from "react";
//import './Details.css';
import { Component } from "react";
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
//import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';

class Resetpass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            resetemail: "",
            newpassword: "",
            username:""
        }
    }

    setNewPassword = (e) => {
        // console.log(e.target.value)
        this.setState({
            newpassword: e.target.value,
        });
    };

    setResetUserName = (e) => {
        this.setState({
            resetemail: e.target.value, username: e.target.value
        });
    };

    onResetPassClose = () => {
        this.setState({ resetpass: "", resetemail: "", newpassword: "", username:"" });
    }



    handleResetPassOpen = () => {
        this.setState({ open: true });
    };

    handleResetClose = () => {
        this.setState({
            open: false, resetemail: "", newpassword: ""
        });
        document.getElementById('successReset').style.display = "none";
        document.getElementById('failReset').style.display = "none";
        document.getElementById('userNotFound').style.display = "none";
        this.props.onResetPassClose();
        // this.props.loadProduct();
    };
    render() {

        return (
            <div>
                <Modal ariaHideApp={false} isOpen={this.state.open} onClose={this.handleResetClose}
                >
                    <Form >
                        <div style={{fontFamily:"lora", minHeight:"80vh", paddingTop: "20vh", paddingLeft:"5px", color:"darkblue", fontSize:"18px",
                            paddingRight:"5px", borderRadius:"10px" }}>
                            <div style={{color: "darkblue", textAlign: "center", fontStyle: "italic", fontWeight: "bold", textShadow: "1px 1px 2px white" }}><Label> <h3>iWash Laundry App</h3></Label></div>
                            <div style={{color: "darkblue", textAlign: "center", fontStyle: "italic", fontWeight: "bold", textShadow: "1px 1px 2px white" }}><Label> <h5>RESET PASSWORD</h5></Label></div>
                            <FormGroup>                               
                                <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    id="resetusername"
                                    name="resetusername"
                                    placeholder="Enter e-mail address"
                                    onChange={this.setResetUserName}
                                    type="email"
                                    value={this.state.resetemail}
                                />
                            </FormGroup>
                            <FormGroup>                                
                                <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    id="newpassword"
                                    name="newpassword"
                                    placeholder="Set new password"
                                    onChange={this.setNewPassword}
                                    type="password"
                                    value={this.state.newpassword}
                                />
                            </FormGroup>
                            <div id='successReset' style={{ textAlign: "center", color: "green", display: "none" }}><Label> <h4>Password successfuully reset!</h4></Label></div>
                            <div id='failReset' style={{ textAlign: "center", color: "red", display: "none" }}><Label> <h4>Password reset failed!</h4></Label></div>
                            <div id='userNotFound' style={{ textAlign: "center", color: "red", display: "none" }}><Label> <h4>User {this.state.username} not found, reset failed!</h4></Label></div>
                            <div id="btnSubmit" style={{ paddingTop: "20px" }}>
                                <Button style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", fontWeight: "bold", color: "white" }} onClick={this.resetPassword}>Submit</Button>
                            </div>
                            <div style={{ paddingTop: "20px" }}>
                                <Button style={{ width: "100%", fontWeight: "bold" }}
                                    onClick={this.handleResetClose}>
                                    Close
                                </Button>
                            </div>
                        </div>

                    </Form>
                </Modal>
            </div>

        )
    }

}
export default Resetpass